
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/3",
      function () {
        return require("private-next-pages/project/3/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/3"])
      });
    }
  